import { formCells, signInfoCells, signSpaceCells, detailFormCells } from '../columns/baseColumns';

export default {
  data() {
    return {
      baseColumns: [],
      baseRules: {
        nicheCompanyNo: { required: true, message: '必填字段' },
        nicheDepartmentCode: { required: true, message: '必填字段' },
        customerCode: { required: true, message: '必填字段' },
      },
      disableNicheProcess: false,
      intentionSpacesDisabled: false,
      followingRecordsDisabled: false,
    };
  },
  methods: {},
  computed: {
    getSignInfoColumns() {
      return signInfoCells();
    },
    getSignSpacesColumns() {
      return signSpaceCells();
    },
    getProcessedBaseColumns() {
      let tl = formCells(this);
      let tlDetail = detailFormCells(this);

      if (this.pageMode == 0) {
        return tl.map((item) => {
          if (item.prop == 'nicheCompanyNo') {
            return { ...item, disabled: true };
          }
          return item;
        });
      } else if (this.pageMode == 1) {
        this.disableNicheProcess = true;
        this.intentionSpacesDisabled = true;
        this.followingRecordsDisabled = true;
        return tlDetail.map((item) => {
          return { ...item, disabled: true };
        });
      } else if (this.pageMode == 2) {
        this.disableNicheProcess = false;
        this.intentionSpacesDisabled = false;
        this.followingRecordsDisabled = false;
        return tl.map((item) => {
          if (item.prop == 'nicheCompanyNo') {
            return { ...item, disabled: true };
          }
          return item;
        });
      }

      return tl;
    },
  },
  mounted() {
    // this.baseColumns = formCells(this);
  },
};
